import { Widgets } from '../types/widgets'
import { widgetId } from './widgetId'

export const defaultWidgets: Widgets = {
  visible: [
    { id: widgetId.Invoices },
    { id: widgetId.CegidEInvoices },
    { id: widgetId.BankIntegration },
    { id: widgetId.Bills },
    { id: widgetId.CarouselUpsell },
  ],
  hidden: [
    { id: widgetId.CashPilot },
    { id: widgetId.Graph },
    { id: widgetId.Overview },
    { id: widgetId.FindAccountant },
    { id: widgetId.Vat },
    { id: widgetId.TopCustomers },
    { id: widgetId.Tasks },
    { id: widgetId.TopVendors },
  ],
}

export const defaultWidgetsAfterDayFromRegistering: Widgets = {
  visible: [
    { id: widgetId.Graph },
    { id: widgetId.Invoices },
    { id: widgetId.CegidEInvoices },
    { id: widgetId.BankIntegration },
    { id: widgetId.CarouselUpsell },
    { id: widgetId.Bills },
    { id: widgetId.CashPilot },
    { id: widgetId.FindAccountant },
    { id: widgetId.Vat },
    { id: widgetId.Tasks },
    { id: widgetId.TopVendors },
  ],
  hidden: [{ id: widgetId.Overview }, { id: widgetId.TopCustomers }],
}
